import React from 'react';
import { Link } from 'react-router-dom';
import SupervisorLayout from '../../components/SupervisorLayout';
import { useSupervisorAuth } from '../../context/SupervisorAuthContext';
import './SupervisorCentralPage.css';

// Grille d'icones "Controles" du superviseur (2026-09-24) — memes items que le
// dropdown "Controles" du nav (SupervisorLayout.jsx), redondance volontaire
// comme SupervisorParametresPage/SupervisorCentralPage. Gates par
// SupervisorMenuPermission : une tuile non accordee n'apparait pas.
export const controlesItems = [
  { label: 'Parametres de loterie', icon: '🎯', path: '/supervisor/product-configs' },
  { label: 'Limites par numero', icon: '🔢', path: '/supervisor/number-limits' },
];

const SupervisorControlesPage = () => {
  const { supervisor } = useSupervisorAuth();
  const granted = new Set(supervisor?.menu_keys || []);
  const visibleItems = controlesItems.filter((item) => granted.has(item.path));

  return (
    <SupervisorLayout>
      <p className="svc-breadcrumb">
        Ruta : <Link to="/supervisor/dashboard" className="svc-link">Menu</Link>
        {' >> '}
        <Link to="/supervisor/controles" className="svc-link">Controles</Link>
      </p>

      {visibleItems.length === 0 ? (
        <p>Aucun controle accorde — demande a la company de t'en donner l'acces.</p>
      ) : (
        <div className="svc-grid">
          {visibleItems.map((item) => (
            <Link key={item.label} to={item.path} className="svc-item">
              <div className="svc-icon">{item.icon}</div>
              <span className="svc-label">{item.label}</span>
            </Link>
          ))}
        </div>
      )}
    </SupervisorLayout>
  );
};

export default SupervisorControlesPage;
